import { isNil, omitBy } from 'lodash';
import { useMemo } from 'react';

import { LibraryFilter } from '@/enums/LibraryFilter';
import { useQueryParams } from '@/hooks/useQueryParams';

export const useHubsLibraryFilters = (options = {}) => {
  const { change, router, ...params } = useQueryParams(options);
  const filters = useMemo(() => {
    const result = {};

    Object.values(LibraryFilter).forEach((filter) => {
      if (params[filter]) {
        result[filter] = params[filter];
      }
    });

    return result;
  }, [params]);

  const reset = () => {
    const queryParams = {};

    Object.entries(filters).forEach(([key]) => (queryParams[key] = null));

    // replace string /hubs-subdomain/ai from pathname
    const hubsPath = '/hubs-subdomain/[slug]';
    const updatedPathname = router.pathname.replace(hubsPath, '');

    router.replace(
      {
        pathname: updatedPathname,
        query: omitBy(
          {
            ...router.query,
            ...queryParams,
          },
          isNil
        ),
      },
      undefined,
      { scroll: false }
    );
  };

  return { change, reset, filters, router };
};
